import { classNames } from '@dimjs/utils';
import { hooks } from '@wove/react';
import { Fragment, ReactElement, ReactNode } from 'react';
import { CheckListItem, CheckListItemContentProps, CheckListItemProps } from '../check-list';
import { CheckIcon, CheckIconProps } from '../icon/check-icon';
import { Space } from '../space';

export type CheckboxItemProps = {
  reverse?: boolean;
  checkIconProps?: Pick<CheckIconProps, 'style'>;
  clickArea?: 'all' | 'checkIcon';
  className?: string;
  children?: ReactElement;
} & CheckListItemProps;

type CheckboxItemContentProps = CheckListItemContentProps &
  Pick<CheckboxItemProps, 'reverse' | 'checkIconProps' | 'clickArea'> & { children?: ReactNode };

const CheckboxItemContent = (props: CheckboxItemContentProps) => {
  const clickArea = props.clickArea || 'all';

  const onClick = hooks.useCallbackRef((area, event) => {
    if (area === clickArea) {
      props.onClick?.(event);
    }
  });

  const childrens = [
    <CheckIcon
      key="0"
      {...props.checkIconProps}
      checked={props.checked}
      disabled={props.disabled}
      onClick={onClick.bind(null, 'checkIcon')}
    />,
    <Fragment key="1">{props.children}</Fragment>,
  ];
  return (
    <Space
      gap={18}
      className={classNames('v-checkbox-item', { 'v-checkbox-item-reverse': props.reverse }, props.className)}
      onClick={onClick.bind(null, 'all')}
      justifyContent={props.reverse ? 'space-between' : 'left'}
    >
      {props.reverse ? childrens.reverse() : childrens}
    </Space>
  );
};

/**
 * ```
 *  reverse: 勾选区域和文字区域位置对换
 *  clickArea: 点击区域
 * ```
 */
export const CheckboxItem = (props: CheckboxItemProps) => {
  return (
    <CheckListItem value={props.value} disabled={props.disabled}>
      <CheckboxItemContent
        reverse={props.reverse}
        checkIconProps={props.checkIconProps}
        clickArea={props.clickArea}
        className={props.className}
      >
        {props.children}
      </CheckboxItemContent>
    </CheckListItem>
  );
};
